import React, { useState, useEffect } from 'react'
import { Doughnut } from 'react-chartjs-2';
import { Line } from 'react-chartjs-2'
import { FaTimesCircle } from 'react-icons/fa'
import { useStateContext } from '../../../state/context';
import { useSelector } from 'react-redux';
import { Chart as ChartJs, Title, Tooltip, LineElement, Legend, CategoryScale, LinearScale, PointElement } from 'chart.js'
ChartJs.register(
    Title, Tooltip, LineElement, Legend,
    CategoryScale, LinearScale, PointElement
)

const PatientRespiratoryChartModal = () => {
    const { modals, setModals } = useStateContext()
    const { all_patient_performanceData } = useSelector((state) => state.nurse)
    const respiration_data = []
    const date_data = []
    const getRespirationData = () => {
        all_patient_performanceData?.map((item, index) => {
            let respiration = parseInt(item.respiration)
            respiration_data.push(respiration)
        })
    }
    const getDateData = () => {
        all_patient_performanceData?.map((item, index) => {
            let date = item.date
            date_data.push(date)
        })
    }

    const [data, setData] = useState({
        labels: date_data,
        datasets: [
            {
                label: "Respiratory Chart",
                data: respiration_data,
                backgrounColor: "yellow",
                borderColor: "green",
                tension: 0.4,
                fill: true,

            }
        ]
    })

    useEffect(() => {

        getRespirationData()
        getDateData()
    }, [])

    return (
        <>
            <div className='absolute grid h-screen w-full z-20 bg-[#11111180] place-items-center'>
                <div className='bg-white rounded px-[30px] py-[20px] h-[500px] w-[800px]'>
                    <h1 className='font-semibold text-blue-400'>Patient Respiratory Chart</h1>
                    <div className='flex justify-end'>
                        <p></p>
                        <FaTimesCircle
                            className='text-dark-yellow cursor-pointer'
                            onClick={() => (
                                setModals({
                                    ...modals,
                                    showRespiratoryChartModal:
                                        !modals.showRespiratoryChartModal,
                                })
                            )

                            }
                            size={20}
                        />
                    </div>

                    <div className='flex flex-col space-y-5 justify-end'>

                        <div className='flex justify-between items-center'>

                            <Line data={data}>PatientTemperatureChartModal</Line>

                        </div>

                    </div>
                </div>

            </div>
        </>
    )
}

export default PatientRespiratoryChartModal